import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const Skills = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(true);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard mb-5">
      <div className="col col-12">
        {edit && <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} />}
        <Info userCopy={userCopy} setUserCopy={setUserCopy} setUser={setUser} setEdit={setEdit} edit={edit} />
      </div>
    </div>
  );
};

export default Skills;

const Info = ({ userCopy, setUserCopy, setUser, setEdit, edit }) => {
  const handleRemoveSkills = (_id) => {
    const newUserCopy = { ...userCopy };
    let expArr = newUserCopy.skills;
    expArr = expArr.filter((el) => el._id !== _id);
    newUserCopy.skills = expArr;

    editUser(newUserCopy, setUser);
  };

  return (
    <>
      {!edit && (
        <h2 className="heading">
          <span>Skills</span>
          <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
            <i className="bi bi-plus-circle"></i> Add new
          </button>
        </h2>
      )}
      <div className="content mx-5" style={{ paddingTop: '0' }}>
        <div className="main hr" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {userCopy?.skills?.length === 0 && (
            <div className="col col-12">
              <span className="lead">No details has been provided yet.</span>
            </div>
          )}
          {userCopy.skills &&
            userCopy.skills.map((el) => (
              <span className="skill-badge">
                <span>{el.name}</span>
                <span className="skill-badge-close" onClick={() => handleRemoveSkills(el._id)}>
                  <i className="bi bi-x-circle"></i>
                </span>
              </span>
            ))}
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const [form, setForm] = useState({ name: '' });

  const handleSubmit = (e) => {
    e.preventDefault();

    const expObj = { ...form };

    const newUserCopy = { ...userCopy };
    const expArr = newUserCopy.skills;
    expArr.push(expObj);
    newUserCopy.skills = expArr;

    setForm((prev) => ({ ...prev, name: '' }));
    editUser(newUserCopy, setUser);
  };

  return (
    <>
      <h2 className="heading">
        Skills
        <span></span>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-12">
              <label htmlFor="inputSkills" className="form-label">
                Select your skills
              </label>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  style={{ height: '43px' }}
                  id="inputSkills"
                  placeholder="select your skill, e.g. Microsoft Office"
                  value={form.name}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, name: e.target.value };
                    })
                  }
                />
                <button type="submit" className="btn profile-btn mb-1 ms-3" style={{ height: '43px' }}>
                  Add
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
